import React from "react";
import {TableContext, TableV2} from "@q4us-sw/q4us-ui/lib/TableV2";
import {TableFilter} from "../filters/TableFilter";
import {MapToFilter} from "../../utils/mappings";
import {getFeConfig, selfRegInvite, submitEM, visualizeLoad} from "../../api/api";
import {Button, Input, Modal, notification, Space, Typography} from "antd";
import '../../styles/Invitations.css'
import {toEm} from "../../self-reg/util";
import {InfoCircleOutlined, LoadingOutlined} from "@ant-design/icons";
import {unstable_batchedUpdates} from "react-dom";


export const Invitations = (props) => {

    const fetchData = async (values, page = {}) => {
        const filters = MapToFilter(values)
        return await visualizeLoad({
            tableName: 'invites_view',
            orderBy: ['id desc'],
            filter: [...filters],
            page: {size: page.size || 100, from: ((page.current || 1) - 1) * (page.size || 100)}
        }) || {}
    }

    const [email, setEmail] = React.useState();
    const [visible, setVisible] = React.useState(false);
    const [loading, setLoading] = React.useState(false)


    return <React.Fragment>
            <TableV2
                header={
                    <div className={`invite-header-wrap`}>
                        <div className={`invite-filter-wrap`}>
                            <TableFilter schema={'self_reg_invites_filter'} fetch={fetchData}/>
                        </div>

                        <div className={`invite-invite-btn-wrap`}>
                            <Button onClick={()=>{
                                setVisible(true)
                            }} type={"primary"}>Invite</Button>
                        </div>
                    </div>

                }
                minColumnWidth={250}
                maxColumnWidth={400}
                fetchConfig={async (schema) => {
                    return await getFeConfig(schema)
                }}
                schema={"self_reg_invites"}
                fetchData={async (request) => {
                    return await fetchData(request.options.filter || {}, request.page)
                }}
                scroll={{x: 'max-content', y: 'calc(100vh - 150px - 95px)'}}
            >
                <Modal
                    closable={false}
                    title={null}
                    visible={visible}
                    width={416}
                    footer={null}
                    className={"ant-modal ant-modal-confirm ant-modal-confirm-confirm"}
                >
                    <div className="ant-modal-confirm-body-wrapper">
                        <div className="ant-modal-confirm-body">
                            <InfoCircleOutlined/>
                            <span className="ant-modal-confirm-title">{`Send Invitation`}</span>
                            <div className="ant-modal-confirm-content">
                                <div className={`single-shipment-dialog`}>
                                    <div className={`title`}>Email</div>
                                    <div>
                                        <Input name={`email`} size={"large"} placeholder={`Email address`} type={email} value={email}
                                               onChange={(e) => setEmail(e.target.value)}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ant-modal-confirm-btns">
                            <Button onClick={() => {
                                unstable_batchedUpdates(() => {
                                    setVisible(false)
                                    setLoading(false)
                                    setEmail(undefined);
                                })

                            }}>No</Button>
                            <TableContext.Consumer>
                                {table=><Button icon={loading ? <LoadingOutlined/> : undefined} className="ant-btn-dangerous"
                                                onClick={async () => {
                                                    setLoading(true)
                                                    await selfRegInvite(email)
                                                    table?.setLoading(true)
                                                    const res = await table?.props.fetchData({schema: table?.props?.schema, page: table?.page, options: table?.customData});
                                                    unstable_batchedUpdates(() => {
                                                        table?.setData(res.data?.rows || [])
                                                        table?.setLoading(false)
                                                        setVisible(false)
                                                        setLoading(false)
                                                        setEmail(undefined);
                                                    })
                                                }}>Yes</Button>}
                            </TableContext.Consumer>

                        </div>
                    </div>
                </Modal>

            </TableV2>


    </React.Fragment>
}
